import React, { useState } from 'react';
import { client, consoleLogInDev, track } from 'shared';
import { Dialog, Grid } from '@material-ui/core';
import { Text, PrimaryButton } from 'library';
import JustBookedModal from './JustBookedModal';
import SendToOthers from './SendToOthers';
import { makeInstantBooking } from 'api/InstantBookApi';

export default function InstantBookConfirmModal({
    visible,
    setVisible,
    providerName,
    onClose,
    bookingId,
    promoCode,
    setPromoCode,
}: {
    visible: boolean;
    setVisible: any;
    providerName: string;
    onClose: () => void;
    bookingId: number;
    promoCode?: string | null;
    setPromoCode?: (promoCode: string | null) => void;
}) {
    const [isBookedModal, setIsBookedModal] = useState(false);
    const [sendToOthers, setSendToOthers] = useState(true);
    return (
        <>
            <JustBookedModal
                visible={isBookedModal}
                onClose={() => setIsBookedModal(false)}
                providerName={providerName}
            />
            <Dialog
                fullWidth
                disableEnforceFocus
                maxWidth="sm"
                open={visible}
                onClose={onClose}
                scroll="paper"
                PaperProps={{
                    style: {
                        boxShadow: 'none',
                        borderRadius: 18,
                    },
                }}
            >
                <Grid container xs={12} style={{ padding: 24 }}>
                    <Grid item xs={12} direction="row" justify="space-between" container style={{ marginBottom: 10 }}>
                        <Text variant="h1">Confirm your booking with {providerName}</Text>
                        <Text variant="body1" onClick={onClose}>
                            x
                        </Text>
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item xs={12}>
                            <Text variant="body1" textStyle={{ paddingBottom: 10 }}>
                                Once you book we'll confirm with {providerName} and you'll see your new job on your
                                dashboard.
                            </Text>
                        </Grid>
                        <SendToOthers
                            providerName={providerName}
                            sendToOthers={sendToOthers}
                            setSendToOthers={setSendToOthers}
                        />

                        <PrimaryButton
                            buttonStyle={{ marginTop: 20 }}
                            onClick={async () => {
                                setVisible(false);
                                setIsBookedModal(true);
                                await makeInstantBooking(bookingId, sendToOthers);
                                if (promoCode) {
                                    track('Instabook: Confirm Full Package Click', { bookingId });
                                    client('api/promo-code/apply', { body: { code: promoCode } })
                                        .then((response: any) => {
                                            consoleLogInDev(response);
                                            setPromoCode?.(null);
                                        })
                                        .catch((error) => {
                                            consoleLogInDev(error);
                                        });
                                }
                                onClose();
                                track('Confirmed Instant Book From Profile');
                            }}
                        >
                            Confirm Booking
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
}
